import { render, staticRenderFns } from "./partner-catalog.vue?vue&type=template&id=f892a9a2&scoped=true&"
import script from "./partner-catalog.ts?vue&type=script&lang=ts&"
export * from "./partner-catalog.ts?vue&type=script&lang=ts&"
import style0 from "./partner-catalog.scss?vue&type=style&index=0&id=f892a9a2&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f892a9a2",
  null
  
)

export default component.exports